/**
 * The Pyr Arcade (Neuron Tetris) is built but held back (Ames 2026-10-20:
 * "remind me to add it at a later time for like new years celebration").
 * Set to true, and add a changelog entry, to give players the menu entry and
 * the palette command. Until then the game is not reachable.
 */
export const ARCADE_ENABLED = false;
